import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import AccountLinks from '~/shared/components/AccountLinks';
import { mobile } from '~/techstyle-shared/react-components';

const Wrapper = styled.div`
  ${mobile`display: none;`};
`;

const AccountPageMenuDesktopAccountLinks = styled(AccountLinks)`
  ${AccountLinks.List} {
    width: 154px;
  }
  ${AccountLinks.Link} {
    color: ${(props) => props.theme.colors.textDefault};
  }
  [data-path-hierarchy='exact'],
  [data-path-hierarchy='within'] {
    font-weight: bold;
  }
`;

export default function AccountPageMenuDesktop({ className }) {
  return (
    <Wrapper className={className}>
      <AccountPageMenuDesktopAccountLinks />
    </Wrapper>
  );
}

AccountPageMenuDesktop.propTypes = {
  className: PropTypes.string,
};
